<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/jXBZAK/tc-custom/9781948239417.jpg?1700958076978" alt="This image is the cover for the book Red Son, The Red Family Trilogy"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Red Son, The Red Family Trilogy
      </h1>
      <p class="bookDescription body article font2">
        <b>A serial killer haunts a darkened land in a macabre contest of survival in book one of this horror fantasy trilogy.</b><br/><br/> In 1999, the world is horribly altered by a mysterious, year-long phenomenon dubbed the Great Darkness. A serial killer known as the Family Man is drawn deep into this strange new landscape by the enigmatic Shepard of Wolves. As he receives clues to his fate through the powerful Red Dream, the Family Man goes searching for answers.<br/><br/> A kill list contains the names of other monstrous killers, some even more infamous than the Family Man. They have been drawn into the Shepard's Game—the ultimate contest of death—and the prize is worth every drop of blood spilled in its name. But is this all a trap? Who is the Red Mother, and what does she want? Should the Family Man add the Shepard to his list?<br/><br/> Striking the killers' names from his list one gruesome stroke at a time, the Family Man unravels the truth. But his own personal war against the waking world demands a heavy price—he must rouse the demons of his buried past.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mark Anzalone
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      WildBlue Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?349d77b0